<template lang="html">
  <span
    :class="[
      `button--${type}`,
      `button--size-${size}`,
      !padded && 'button--not-padded',
    ]"
    class="button"
    v-on="$listeners"
  >
    <span
      v-if="$slots['before']"
      class="button__before"
    >
      <slot name="before" />
    </span>
    <slot />
    <span
      v-if="$slots['after']"
      class="button__after"
    >
      <slot name="after" />
    </span>
  </span>
</template>

<script>
import VueTypes from 'vue-types'

export default {
  props: {
    type: VueTypes.oneOf([
      'default',
      'bare',
      'primary',
      'secondary'
    ]).def('default'),
    padded: {
      type: Boolean,
      default: true
    },
    size: VueTypes.oneOf([0, 1])
  }
}
</script>

<style lang="scss">
  @import 'beisheim/scss/font-sizes';
  @import 'beisheim/scss/colors';
  @import 'beisheim/scss/scale';
  @import 'beisheim/scss/px-to-rem';

  .button {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    border: none;
    font-size: font-size(0);
    text-decoration: none;
    outline: 0;
    border: 1px solid transparent;
    border-radius: px-to-rem(25px);
    padding: scale(2) scale(4);
    white-space: nowrap;

    &:disabled {
      cursor: not-allowed;
    }
  }

  .button--not-padded {
    padding: 0;
  }

  .button--bare {
    background-color: transparent;
    border-color: transparent;
    color: gray(1);

    &:hover, &:focus {
      text-decoration: underline;
    }
  }

  .button--default {
    background-color: gray(4);
    border-color: gray(4);
    color: gray(2);

    &:hover {
      background-color: gray(3);
      border-color: gray(3);
      color: gray(1);
    }
  }

  .button--primary {
    background-color: gray(0);
    border-color: gray(0);
    color: gray(5);

    &:hover {
      background-color: gray(2);
      border-color: gray(2);
      color: gray(5);
    }
  }

  .button--secondary {
    background-color: transparent;
    border-color: gray(3);
    color: gray(1);

    &:hover {
      background-color: gray(4);
      border-color: gray(4);
      color: gray(2);
    }
  }

  .button__before {
    margin-right: scale(2);

    svg {
      width: 24px;
    }
  }

  .button__after {
    margin-left: scale(2);
  }

  .button--size-1 {
    font-size: font-size(1);

    svg {
      width: 36px;
    }
  }

</style>
